export default __webpack_public_path__ + "static/media/leadBundle2.6b6be870.svg";